import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import { Text } from '@radix-ui/themes';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const DataTableToggler = (props: {
  expanded: boolean;
  onToggle: () => void;
}) => (
  <Text
    color={RADIX.COLOR.ACCENT}
    className="cursor-pointer"
    onClick={props.onToggle}
  >
    {t(
      props.expanded ? 'common.hide-training-data' : 'common.show-training-data'
    )}
    &nbsp;
    {props.expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
  </Text>
);
